import React, { useState } from 'react';
import blogPosts from './data/blogPosts';
import { Link } from 'react-router-dom';

function Blog({ language }) {
  const isLTR = ['en', 'fr'].includes(language);

  const translations = {
    ar: {
      pageTitle: 'مقالات الهداية',
      searchPlaceholder: 'ابحث عن مقالات...',
      noResults: 'لا توجد مقالات متطابقة مع بحثك',
    },
    en: {
      pageTitle: 'Articles of Guidance',
      searchPlaceholder: 'Search articles...',
      noResults: 'No articles match your search',
    },
    fr: {
      pageTitle: 'Articles de la guidance',
      searchPlaceholder: 'Rechercher des articles...',
      noResults: 'Aucun article ne correspond à votre recherche',
    },
  };

  const t = translations[language] || translations.ar;

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 4;

  // Filtrer les articles par recherche
  const filteredPosts = blogPosts.filter(post => {
    const title = post.titles[language].toLowerCase();
    const date = post.dates[language];
    const search = searchTerm.toLowerCase();
    return title.includes(search) || date.includes(searchTerm);
  });

  // Pagination
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className='about-container-inner'>
      <div className="about-container">
        <h1
          className={`about-title ${isLTR ? 'english-title' : ''}`}
          dir={isLTR ? 'ltr' : 'rtl'}
          lang={language}
        >
          {t.pageTitle}
        </h1>

        {/* Barre de recherche */}
        <div className="blog-search-container">
          <input
            type="text"
            placeholder={t.searchPlaceholder}
            className={`blog-search-input ${isLTR ? 'english-text' : ''}`}
            dir={isLTR ? 'ltr' : 'rtl'}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1); // Reset à la première page lors d'une nouvelle recherche
            }}
          />
        </div>

        {currentPosts.length === 0 ? (
          <p
            className={`about-text ${isLTR ? 'about-english' : ''}`}
            dir={isLTR ? 'ltr' : 'rtl'}
            style={{ textAlign: isLTR ? 'left' : 'right' }}
          >
            {t.noResults}
          </p>
        ) : (
          <>
            <div className="blog-grid">
              {currentPosts.map((post) => (
                <div key={post.slug} className="blog-card">
                  <img
                    src={post.image || "/logo.jpg"}
                    alt={post.titles[language]}
                    className="blog-card-image"
                  />
                  <div className="blog-card-content">
                    <Link
                      to={`/blog/${post.slug}`}
                      className={`blog-card-title ${isLTR ? 'about-english' : ''}`}
                      dir={isLTR ? 'ltr' : 'rtl'}
                    >
                      {post.titles[language]}
                    </Link>
                    <p
                      className="blog-card-date"
                      dir={isLTR ? 'ltr' : 'rtl'}
                    >
                      {post.dates[language]}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="blog-pagination">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
                  <button
                    key={number}
                    className={`blog-page-button ${currentPage === number ? 'active' : ''} ${isLTR ? 'english-text' : ''}`}
                    onClick={() => paginate(number)}
                  >
                    {number}
                  </button>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Blog;
